import { useState } from "react";
import "react-datepicker/dist/react-datepicker.css";

import { CiMaximize1, CiMinimize1 } from "react-icons/ci";
import { DatePicker, ConfigProvider, Input, Spin, Tooltip, Select } from 'antd';
import dayjs from 'dayjs';
import ptBR from 'antd/lib/locale/pt_BR';

import options from "./elements.json";
import { ClearOutlined, LoadingOutlined } from "@ant-design/icons";
import "../style.css";
import { IoSearch } from "react-icons/io5";
import { AnimatedHeaderSidHome } from "../../styledGlobalModal";

const { Option } = Select;

export function HeaderSideHom({ isVisible, onSearch, loading }) {
  const [isReduced, setIsReduced] = useState(false);

  // Estados do Filtro
  const [id, setId] = useState("");
  const [carteira, setCarteira] = useState(null);
  const [equipe, setEquipe] = useState(null);
  const [obrigacao, setObrigacao] = useState("");
  const [selectedArea, setSelectedArea] = useState("R");
  const [selectedDay, setSelectedDay] = useState(null);

  const maskFormat = "MM/YYYY";
  // Inicia com o mês atual
  const [date, setDate] = useState(dayjs().format(maskFormat));

  // Tratamento de options para evitar erro se json estiver vazio
  const optionsCFromJson = options[0]?.optionsC?.map((option) => ({
    value: option.value.toString(),
    label: option.label,
  })) || [];

  const optionsEFromJson = options[0]?.optionsE?.map((option) => ({
    value: option.value.toString(),
    label: option.label,
  })) || [];

  const getDateVencimento = (dateValue) => {
    if (!dateValue) return null;
    // Pega o mês e ano selecionados e fixa o dia 15 para padrão de envio
    return dayjs(dateValue, maskFormat)
      .date(15)
      .hour(0)
      .minute(0)
      .second(0)
      .millisecond(0)
      .toISOString();
  };

  const clearFilters = () => {
    setSelectedDay(null);
    setId("");
    setCarteira(null);
    setEquipe(null);
    setSelectedArea("R");
    setObrigacao("");
    setDate(dayjs().format(maskFormat)); // Volta para data atual
  };

  const onChangeValueDate = (value) => {
    if (value) {
      setDate(value.format(maskFormat));
    } else {
      setDate(null);
    }
  };

  const handleSearch = () => {
    // CORREÇÃO: Passando os parâmetros na ordem exata que o pai espera
    // E removendo duplicidade de variáveis
    onSearch(
      getDateVencimento(date), // 1. Data Vencimento
      id,                      // 2. ID Cliente
      carteira,                // 3. Carteira
      equipe,                  // 4. Equipe
      obrigacao,               // 5. Obrigação (Nome)
      selectedArea,            // 6. Categoria/Area (R, P, A)
      selectedDay              // 7. Dia
    );
  };

  return (
    <AnimatedHeaderSidHome reduced={isReduced} isVisible={isVisible}>

      <div className="hamburger">
        {isReduced ? (
          <Tooltip title="Expandir filtro">
            <div className="btn-hamburger" onClick={() => setIsReduced(!isReduced)}>
              <span className="font-icon"><CiMaximize1 /></span>
            </div>
          </Tooltip>
        ) : (
          <Tooltip title="Minimizar filtro">
            <div className="btn-hamburger" onClick={() => setIsReduced(!isReduced)}>
              <span className="font-icon"><CiMinimize1 /></span>
            </div>
          </Tooltip>
        )}
      </div>

      {/* TODAS ESSAS CLASSES ESTÃO EM AnimatedHeaderSidHome */}
      <div className="content">
        <div className="padding-5">
          <div className="margin-right-5">
            <Input
              type="text"
              value={obrigacao}
              onChange={(event) => setObrigacao(event.target.value)}
              placeholder="Obrigação"
              disabled={loading}
              className="width-long"
            />
          </div>
        </div>

        <div className="display-flex-padding-5">
          <div className="margin-right-5">
            <Select
              placeholder="Dia"
              value={selectedDay || undefined}
              style={{ width: 80 }}
              onChange={(value) => setSelectedDay(value)}
              allowClear
            >
              {options[0]?.days?.map((day) => (
                <Option key={day.value} value={day.value}>
                  {day.label}
                </Option>
              ))}
            </Select>
          </div>

          <div>
            <ConfigProvider locale={ptBR}>
              <DatePicker
                value={date ? dayjs(date, maskFormat) : null}
                format={maskFormat}
                picker="month"
                style={{ width: 215 }}
                onChange={onChangeValueDate}
                allowClear={false}
              />
            </ConfigProvider>
          </div>
        </div>

        <div className="display-flex-padding-5">
          <div className="margin-right-5">
            <Input
              type="text"
              value={id}
              onChange={(event) => setId(event.target.value)}
              placeholder="ID cliente"
              disabled={loading}
              style={{ width: 80 }}
            />
          </div>

          <div>
            <Select
              showSearch
              placeholder="Selecione a carteira"
              filterOption={(input, option) =>
                (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
              }
              options={optionsCFromJson}
              onChange={(value) => setCarteira(value)}
              value={carteira}
              className="width-215 text-align-left"
              allowClear
            />
          </div>
        </div>

        <div className="display-flex-padding-5">
          <div>
            <Select
              showSearch
              placeholder="Selecione a equipe"
              filterOption={(input, option) =>
                (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
              }
              options={optionsEFromJson}
              onChange={(value) => setEquipe(value)}
              value={equipe}
              className="width-215 text-align-left"
              allowClear
            />
          </div>
        </div>

        <div className="text-align-left padding-5">
       
            <label>Categoria: </label>
            <div className="header-flex text-align-left top-20">
                <ul>
                  <li>
                    <input
                      type="radio"
                      name="area"
                      value="R"
                      onChange={(event) => setSelectedArea(event.target.value)}
                      checked={selectedArea === "R"}
                    />
                    Recorrente
                  </li>
                  <li>
                    <input
                      type="radio"
                      name="area"
                      value="P"
                      onChange={(event) => setSelectedArea(event.target.value)}
                      checked={selectedArea === "P"}
                    />
                    Parcelamentos
                  </li>
                  <li>
                    <input
                      type="radio"
                      name="area"
                      value="A"
                      onChange={(event) => setSelectedArea(event.target.value)}
                      checked={selectedArea === "A"}
                    />
                    Avulsos
                  </li>
                </ul>
          
            </div>
       
        </div>

        <div className="text-align-left padding-8 header-flex" >
          <Tooltip title="Limpar filtro">
            <div
              className="sty-btn bg-white margin-right-5" /*ESSAS CLASSE: sty-btn bg-white ESTÃO DENTRO DE bgGlobal.css pois ela é padrão de botoes*/
              onClick={clearFilters}
              style={{ cursor: loading ? "not-allowed" : "pointer" }}
            >
              <ClearOutlined />
            </div>
          </Tooltip>

          <Tooltip title="Pesquisar">
            <div
              className={`sty-btn bg-padrao ${loading ? "bg-white cursor-not-allowed" : "cursor-pointer"}`}
              onClick={!loading ? handleSearch : undefined}
            >
              {loading ? (
                <Spin indicator={<LoadingOutlined spin />} size="small" />
              ) : (
                <IoSearch />
              )}
            </div>
          </Tooltip>

          
        </div>
      </div>
    </AnimatedHeaderSidHome>
  );
}

export default HeaderSideHom;